import { useEffect } from 'react';
import useErrors from '../../error/useErrors';
import { useErrorStore } from '../../error';
import { serviceErrorSerializer } from './serviceErrors';
import { inputValidator } from './inputErrors';

/*
 * This serve as a wrapper for useErrors hook to configure the result of useErrors hook.
 */
function useApiKeyErrors (props) {
    const {
        input,
    } = props;

    const store = useErrorStore();

    const {
        errors,
        hasError,
        hasInputError,
        isGenericError,
    } = useErrors({
        hook: 'useApiKeyErrors',
        input,
        inputValidator,
        serviceErrorSerializer,
        errorObservables: [
            store.observed.errors.getAPIKeys,
            store.observed.errors.generateAPIKey,
            store.observed.errors.activateAPIKey,
            store.observed.errors.deactivateAPIKey,
            store.observed.errors.deleteAPIKey,
        ],
    });

    useEffect(() => {
        console.log('');
        console.log('');
        console.log('');
        console.log('useApiKeyErrors() Error Updates...', errors);
    }, [errors]);

    /*
     * This response will be consumed by the UI components...
     */
    return {
        errors,
        hasError,
        hasInputError,
        isGenericError,
    };
}

export default useApiKeyErrors;
